<script lang="ts">

  const lastUpdated = '2026년 8월 21일'
  const serviceName = 'AX Hub'
  const contactEmail = 'support@1pass.dev'
</script>

  <div class="max-w-3xl mx-auto">
    <!-- Header -->
    <div class="mb-8">
      <div class="flex items-center gap-2 text-caption text-content-tertiary mb-4">
        <a href="/" class="hover:text-primary transition-colors">홈</a>
        <span>/</span>
        <span class="text-content">이용약관</span>
      </div>
      <h1 class="text-h1 text-content mb-2">이용약관</h1>
      <p class="text-body2 text-content-tertiary">최종 수정일: {lastUpdated}</p>
    </div>

    <div class="card card-bordered p-8 shadow-md space-y-8">

      <!-- 제1조 -->
      <section>
        <h2 class="text-title text-content mb-4 pb-2 border-b border-default">
          제1조 (목적)
        </h2>
        <p class="text-body2 text-gray-700 dark:text-dark-text-medium leading-relaxed">
          이 약관은 {serviceName}(이하 "서비스")가 제공하는 커뮤니티 서비스의 이용에 관한 조건 및 절차, 회원과 서비스 간의 권리·의무 및 책임사항을 규정함을 목적으로 합니다.
        </p>
      </section>

      <!-- 제2조 -->
      <section>
        <h2 class="text-title text-content mb-4 pb-2 border-b border-default">
          제2조 (정의)
        </h2>
        <div class="space-y-3 text-body2 text-gray-700 dark:text-dark-text-medium leading-relaxed">
          <p>이 약관에서 사용하는 주요 용어의 정의는 다음과 같습니다.</p>
          <ol class="list-decimal list-inside space-y-2 pl-2">
            <li><strong>"서비스"</strong>란 {serviceName}가 운영하는 온라인 커뮤니티 플랫폼을 의미합니다.</li>
            <li><strong>"회원"</strong>이란 서비스에 접속하여 이 약관에 동의하고 소속 인증을 완료한 이용자를 의미합니다.</li>
            <li><strong>"콘텐츠"</strong>란 회원이 서비스에 게시한 게시글, 댓글, 첨부파일 등 일체의 정보를 의미합니다.</li>
            <li><strong>"신고"</strong>란 회원이 타인의 콘텐츠가 이 약관을 위반한다고 판단하여 서비스에 알리는 행위를 의미합니다.</li>
          </ol>
        </div>
      </section>

      <!-- 제3조 -->
      <section>
        <h2 class="text-title text-content mb-4 pb-2 border-b border-default">
          제3조 (서비스 이용)
        </h2>
        <div class="space-y-3 text-body2 text-gray-700 dark:text-dark-text-medium leading-relaxed">
          <p>① 서비스는 회원의 소속 인증(직장 이메일 인증)이 완료된 경우에만 전체 기능을 이용할 수 있습니다.</p>
          <p>② 회원은 자신의 계정을 타인과 공유하거나 양도할 수 없습니다.</p>
          <p>③ 서비스는 서비스 품질 향상, 법령 변경 등의 사유로 언제든지 서비스 내용을 변경하거나 중단할 수 있습니다.</p>
        </div>
      </section>

      <!-- 제4조 -->
      <section>
        <h2 class="text-title text-content mb-4 pb-2 border-b border-default">
          제4조 (금지 행위)
        </h2>
        <div class="p-4 mb-4 bg-error/5 border border-error/20 rounded-xl">
          <p class="text-body2 font-semibold text-error mb-1">무관용 원칙 (Zero Tolerance)</p>
          <p class="text-caption text-gray-700 dark:text-dark-text-medium leading-relaxed">
            서비스는 불쾌감을 주는 콘텐츠와 이용자를 괴롭히는 행위에 무관용 원칙을 적용합니다.
            아래 각 호에 해당하는 콘텐츠는 신고 접수 또는 발견 즉시 삭제하고, 게시한 회원에게는
            제6조의 제재를 적용합니다. 예외나 경고 유예는 없습니다.
          </p>
        </div>
        <p class="text-body2 text-gray-700 dark:text-dark-text-medium mb-4 leading-relaxed">
          회원은 다음 각 호에 해당하는 행위를 하여서는 안 됩니다.
        </p>
        <div class="space-y-3">
          <div class="flex items-start gap-3 p-3 bg-surface-tertiary rounded-xl">
            <span class="badge badge-neutral shrink-0 mt-0.5">1</span>
            <div>
              <p class="text-body2 font-medium text-content">반복 홍보 및 상업적 게시물</p>
              <p class="text-caption text-content-tertiary mt-1">동일 또는 유사한 내용의 반복 게시, 영리 목적의 광고·홍보 (정보통신망법)</p>
            </div>
          </div>
          <div class="flex items-start gap-3 p-3 bg-surface-tertiary rounded-xl">
            <span class="badge badge-neutral shrink-0 mt-0.5">2</span>
            <div>
              <p class="text-body2 font-medium text-content">개인정보 노출</p>
              <p class="text-caption text-content-tertiary mt-1">타인의 실명, 연락처, 계좌번호, 주민등록번호 등 개인정보 게시 (개인정보보호법)</p>
            </div>
          </div>
          <div class="flex items-start gap-3 p-3 bg-surface-tertiary rounded-xl">
            <span class="badge badge-neutral shrink-0 mt-0.5">3</span>
            <div>
              <p class="text-body2 font-medium text-content">불법 콘텐츠</p>
              <p class="text-caption text-content-tertiary mt-1">마약·도박·불법 물품 판매, 저작권 침해 (정보통신망법 §44)</p>
            </div>
          </div>
          <div class="flex items-start gap-3 p-3 bg-error/5 border border-error/20 rounded-xl">
            <span class="badge badge-error shrink-0 mt-0.5">4</span>
            <div>
              <p class="text-body2 font-medium text-error">아동·청소년 성착취물(CSAM)</p>
              <p class="text-caption text-error/70 mt-1">아동·청소년이 등장하는 성적 콘텐츠 게시 엄금 (청소년성보호법 §17)</p>
            </div>
          </div>
          <div class="flex items-start gap-3 p-3 bg-surface-tertiary rounded-xl">
            <span class="badge badge-neutral shrink-0 mt-0.5">5</span>
            <div>
              <p class="text-body2 font-medium text-content">성인물 및 선정적 콘텐츠</p>
              <p class="text-caption text-content-tertiary mt-1">음란·성인물, 과도한 신체 노출 콘텐츠 (정보통신망법)</p>
            </div>
          </div>
          <div class="flex items-start gap-3 p-3 bg-surface-tertiary rounded-xl">
            <span class="badge badge-neutral shrink-0 mt-0.5">6</span>
            <div>
              <p class="text-body2 font-medium text-content">차별·모욕·괴롭힘</p>
              <p class="text-caption text-content-tertiary mt-1">특정인에 대한 차별, 모욕, 인신공격, 따돌림 및 사이버불링 (형법 §311)</p>
            </div>
          </div>
          <div class="flex items-start gap-3 p-3 bg-error/5 border border-error/20 rounded-xl">
            <span class="badge badge-error shrink-0 mt-0.5">7</span>
            <div>
              <p class="text-body2 font-medium text-error">폭력 위협·자해·자살 조장</p>
              <p class="text-caption text-error/70 mt-1">타인에 대한 폭력 위협, 자해·자살 관련 위험 발언 게시 (정보통신망법 §44)</p>
            </div>
          </div>
          <div class="flex items-start gap-3 p-3 bg-surface-tertiary rounded-xl">
            <span class="badge badge-neutral shrink-0 mt-0.5">8</span>
            <div>
              <p class="text-body2 font-medium text-content">허위 정보</p>
              <p class="text-caption text-content-tertiary mt-1">채용 사기, 허위 구인구직, 사실을 왜곡한 기술 정보 게시 (형법 §307)</p>
            </div>
          </div>
        </div>
      </section>

      <!-- 제5조 -->
      <section>
        <h2 class="text-title text-content mb-4 pb-2 border-b border-default">
          제5조 (콘텐츠 신고)
        </h2>
        <div class="space-y-4 text-body2 text-gray-700 dark:text-dark-text-medium leading-relaxed">
          <p>① 회원은 제4조에 해당하는 콘텐츠를 신고할 수 있습니다. 소속 인증 여부와 관계없이 신고할 수 있습니다.</p>
          <p>② 신고된 콘텐츠는 아래 처리 기한 내에 검토됩니다.</p>

          <div class="overflow-hidden rounded-xl border border-default">
            <table class="w-full">
              <thead class="bg-surface-tertiary">
                <tr>
                  <th class="px-4 py-3 text-left text-caption font-semibold text-content-tertiary">신고 유형</th>
                  <th class="px-4 py-3 text-left text-caption font-semibold text-content-tertiary">긴급도</th>
                  <th class="px-4 py-3 text-left text-caption font-semibold text-content-tertiary">처리 기한</th>
                </tr>
              </thead>
              <tbody class="divide-y divide-gray-100 dark:divide-dark-border text-caption">
                <tr class="bg-error/3">
                  <td class="px-4 py-2.5 text-error font-medium">CSAM, 폭력위협/자해/자살</td>
                  <td class="px-4 py-2.5"><span class="badge badge-error">긴급</span></td>
                  <td class="px-4 py-2.5 text-error font-medium">24시간 이내</td>
                </tr>
                <tr>
                  <td class="px-4 py-2.5 text-gray-700 dark:text-dark-text-medium">개인정보 노출, 불법 콘텐츠, 차별/모욕, 허위 정보</td>
                  <td class="px-4 py-2.5"><span class="badge badge-warning">높음</span></td>
                  <td class="px-4 py-2.5">72시간 이내</td>
                </tr>
                <tr>
                  <td class="px-4 py-2.5 text-gray-700 dark:text-dark-text-medium">반복 홍보, 성인물, 기타</td>
                  <td class="px-4 py-2.5"><span class="badge badge-neutral">보통</span></td>
                  <td class="px-4 py-2.5">7일 이내</td>
                </tr>
              </tbody>
            </table>
          </div>

          <p>③ 서비스는 신고 접수 후 정보통신망법 §44에 따라 임시 조치(30일 이내)를 취할 수 있습니다.</p>
          <p>④ 신고자 정보는 피신고자에게 공개되지 않습니다.</p>
          <p>⑤ 허위 신고가 반복되는 경우 서비스 이용이 제한될 수 있습니다.</p>
          <p>⑥ 회원은 다른 회원을 차단할 수 있습니다. 차단하면 그 회원의 글·댓글이 보이지 않고 대화도 차단됩니다. 차단은 설정의 차단 목록에서 언제든 해제할 수 있습니다.</p>
        </div>
      </section>

      <!-- 제6조 -->
      <section>
        <h2 class="text-title text-content mb-4 pb-2 border-b border-default">
          제6조 (위반 시 제재)
        </h2>
        <div class="space-y-3 text-body2 text-gray-700 dark:text-dark-text-medium leading-relaxed">
          <p>① 서비스는 제4조를 위반한 콘텐츠를 삭제하고, 게시한 회원에게 다음 각 호의 제재를 적용합니다.</p>
          <ol class="list-decimal list-inside space-y-2 pl-2">
            <li><strong>경고</strong> — 위반 사실 통지 및 해당 콘텐츠 삭제</li>
            <li><strong>일시 정지</strong> — 7일 또는 30일간 글·댓글 작성 제한</li>
            <li><strong>영구 차단</strong> — 계정 이용 종료 및 재가입 제한</li>
          </ol>
          <p>② 아동·청소년 성착취물(CSAM), 타인에 대한 폭력 위협, 성적 괴롭힘은 1회 위반만으로 영구 차단합니다. 사안에 따라 수사기관에 신고합니다.</p>
          <p>③ 같은 회원에 대한 신고가 반복 접수되어 위반이 확인되면 제1항의 제재를 단계적으로 상향합니다.</p>
          <p>④ 제재를 받은 회원은 <a href="mailto:{contactEmail}" class="text-primary hover:text-primary-dark">{contactEmail}</a> 로 이의를 신청할 수 있고, 서비스는 접수 후 7일 이내에 회신합니다.</p>
        </div>
      </section>

      <!-- 제7조 -->
      <section>
        <h2 class="text-title text-content mb-4 pb-2 border-b border-default">
          제7조 (운영자 의무)
        </h2>
        <div class="space-y-3 text-body2 text-gray-700 dark:text-dark-text-medium leading-relaxed">
          <p>① 서비스는 「정보통신망 이용촉진 및 정보보호 등에 관한 법률」 §44에 따라 불법 정보 유통을 방지하고, 신고 접수 시 신속히 처리할 의무가 있습니다.</p>
          <p>② 서비스는 「아동·청소년의 성보호에 관한 법률」 §17에 따라 아동·청소년 성착취물 발견 시 즉시 삭제하고 수사기관에 신고할 의무가 있습니다.</p>
          <p>③ 서비스는 회원의 개인정보를 「개인정보보호법」에 따라 보호할 의무가 있습니다.</p>
        </div>
      </section>

      <!-- 부칙 -->
      <section>
        <h2 class="text-title text-content mb-4 pb-2 border-b border-default">
          부칙
        </h2>
        <div class="text-body2 text-gray-700 dark:text-dark-text-medium leading-relaxed space-y-2">
          <p>이 약관은 {lastUpdated}부터 시행됩니다.</p>
          <p>이 약관에 명시되지 않은 사항은 관계 법령 및 상관례에 따릅니다.</p>
        </div>
      </section>

    </div>

    <!-- 관련 링크 -->
    <div class="mt-6 flex items-center justify-center gap-4 text-body2">
      <a href="/privacy" class="text-primary hover:text-primary-dark transition-colors">개인정보처리방침</a>
      <span class="text-gray-300 dark:text-dark-text-disabled">|</span>
      <a href="/" class="text-content-tertiary hover:text-primary transition-colors">홈으로</a>
    </div>
  </div>
